import * as React from "react";

import {
  Modal,
  Form,
  FormGroup,
  Label,
  Input,
  ModalFooter,
  Button,
  ModalBody,
  ModalHeader,
} from "reactstrap";

import i18n from "../i18n";

export interface SSMLEditProps {
  item: any;
  isOpen: boolean;
  isNew: boolean;
  onSave: (model: any) => void;
  onCancel: () => void;
}
export interface SSMLEditState {
  item: any;
}

export default class SSMLEdit extends React.Component<
  SSMLEditProps,
  SSMLEditState
> {
  constructor(props: SSMLEditProps) {
    super(props);
    this.state = {
      item: props.item
    };
  }

  componentWillReceiveProps(nextProps: SSMLEditProps) {
    this.setState({
      item: nextProps.item
    });
  }

  render() {
    const { isOpen, onSave, onCancel, isNew } = this.props;
    const model = this.model;
    return (
      <Modal isOpen={isOpen}>
        <ModalHeader>
          {isNew ? i18n.SSML.Form.NewTitle : i18n.SSML.Form.EditTitle}
        </ModalHeader>
        <ModalBody>
          {model && (
            <Form>
              <FormGroup>
                <Label>{i18n.SSML.Table.Word}</Label>
                <br />
                {!isNew && model.rowKey}
                {isNew && (
                  <Input
                    size={50}
                    value={model.rowKey}
                    onChange={e => this.updateField("rowKey", e)}
                  />
                )}
              </FormGroup>
              <FormGroup check={true}>
                <Label check={true}>
                  <Input
                    size={50}
                    type="checkbox"
                    checked={model.caseSensitive}
                    onChange={e => this.updateField("caseSensitive", null, e.target.checked)}
                  />
                  {i18n.SSML.Table.CaseSensitive}
                </Label>
              </FormGroup>
              <FormGroup check={true}>
                <Label check={true}>
                  <Input
                    size={50}
                    type="checkbox"
                    checked={model.spaceSensitive}
                    onChange={e => this.updateField("spaceSensitive", null, e.target.checked)}
                  />
                  {i18n.SSML.Table.SpaceSensitive}
                </Label>
              </FormGroup>
              <FormGroup>
                <Label>
                  {i18n.SSML.Table.Replacement}
                  <Input
                    size={50}
                    value={model.ssmlReplacement}
                    onChange={e => this.updateField("ssmlReplacement", e)}
                  />
                </Label>
              </FormGroup>
            </Form>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => onSave(model)} disabled={!this.isValid}>
            {i18n.Global.Edit.Confirm}
          </Button>
          <Button color="default" onClick={() => onCancel()}>
            {i18n.Global.Edit.Cancel}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  private get model() {
      return this.state.item;
  }

  private get isValid(): boolean {
      return this.model && !!this.model.rowKey;
  }

  private updateField(
    field: string,
    e: React.ChangeEvent<HTMLInputElement> | null,
    value?: any
  ) {
    const temp = {};
    temp[field] = e ? e.target.value : value;
    this.setState({
      item: {
        ...this.state.item,
        ...temp
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/ssml-library/ssml-edit.tsx